class TodoListItem extends HTMLElement {
    constructor() {
        super();
        this.todo = {};
    }
    dispatchDeleteTodoEvent() {
        document.dispatchEvent(new CustomEvent('deleteTodo', { detail: this.todo.id }));
    }
    dispatchCompleteTodoEvent() {
        document.dispatchEvent(new CustomEvent('completeTodo', { detail: this.todo.id }));
    }
    render() {
        const {completed, task} = this.todo;
        const completionStatus = completed ? '\u2705' : '\u26D4';
                this.innerHTML = `<span>
        ${ task }
        <input class="complete-todo" type="checkbox" onchange="this.parentElement.parentElement.dispatchCompleteTodoEvent()">
        <span>${ completionStatus }</span>
        <button class="delete-todo" onclick="this.parentElement.parentElement.dispatchDeleteTodoEvent()">❌</button>
      </span>`;
    }
}
customElements.define('wcc-todo-list-item', TodoListItem);